"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.classNames = void 0;
exports.classNames = {
  luxse: {
    light: 'luxembourg-stock-exchange-light',
    dark: 'luxembourg-stock-exchange-dark'
  },
  lgx: {
    light: 'luxembourg-green-exchange-light',
    dark: 'luxembourg-green-exchange-dark'
  }
};